import React from 'react';
import { Button, Grid, LinearProgress, Stack, Typography } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DownloadIcon from '@mui/icons-material/Download';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import ClearIcon from '@mui/icons-material/Clear';
import { downloadPdfFromUrl } from '../../../../../utils';

const FileDisplayContainerSx = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 5,
    backgroundColor: '#f9f9f9',
    padding: '3rem',
    maxWidth: '50%',
};

const FileSx = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
};

const FileDisplay = ({ file, index, classes, uploadProgress, removeFile }) => {
    const isPdf = (f) => f?.type === 'application/pdf';
    const isImage = (f) => f?.type?.includes('image');

    return (
        <Grid container alignItems="center" sx={FileDisplayContainerSx} xs={12}>
            <Grid item xs={6} key={file.name}>
                {isPdf(file) ? (
                    <Grid sx={FileSx} key={file.name}>
                        <PictureAsPdfIcon color="secondary" fontSize="large" />
                        <Typography sx={{ padding: '5px' }}>{file.name}</Typography>
                    </Grid>
                ) : isImage(file) ? (
                    <Grid sx={FileSx} key={file.name}>
                        <div className={classes.thumb}>
                            <img src={file.url} className={classes.img} alt="" title={file.name} />
                        </div>
                        <Typography sx={{ padding: '5px' }}>{file.name}</Typography>
                    </Grid>
                ) : (
                    <Grid sx={FileSx} key={file.name}>
                        <FilePresentIcon color="secondary" fontSize="large" />
                        <Typography sx={{ padding: '5px' }}>{file.name}</Typography>
                    </Grid>
                )}
            </Grid>
            <Grid item xs={6}>
                <Stack direction="row" spacing={1} justifyContent={'end'}>
                    {file.url != null && (
                        <Button
                            startIcon={<DownloadIcon />}
                            onClick={() => downloadPdfFromUrl(file.url)}
                            variant="outlined"
                            disabled={file.url == null}
                            // wrap
                        >
                            Download
                        </Button>
                    )}
                    <Button onClick={removeFile(index)}>
                        <ClearIcon />
                    </Button>
                </Stack>
            </Grid>
            {file.url == null && <LinearProgress variant="determinate" value={uploadProgress} />}
        </Grid>
    );
};

export default FileDisplay;
